/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PriceColumns {
    FROM_DATE = 'from_date',
    TO_DATE = 'to_date',
    ASKING_RENT = 'asking_rent',
    EFFECTIVE_RENT = 'effective_rent',
    CONCESSION = 'concession',
    AS_OF_WEEK = 'as_of_week',
    AS_OF_MONTH = 'as_of_month',
    AS_OF_QUARTER = 'as_of_quarter',
}
